<template>
  <div
    :class="`${isMovil ? 'content' : 'app-content content'}`"
  >
  <!--
  <div
    :class="[{'show-overlay': $store.state.app.shallShowOverlay}, $route.meta.contentClass]"
  > -->
    <div class="content-overlay" />
    <div
      class="content-wrapper"
      :class="contentWidth === 'boxed' ? 'container p-0' : null"
    >
      <div class="content-body">
        <transition
          :name="routerTransition"
          mode="out-in"
        >
          <slot />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>

import useAppConfig from '@core/app-config/useAppConfig'
import { isMobile } from 'mobile-device-detect'

export default {
  data() {
    return {
      isMovil: isMobile,
    }
  },
  setup() {
    const { routerTransition, contentWidth } = useAppConfig()

    return {
      routerTransition, contentWidth,
    }
  },
}
</script>

<style>

</style>
